/** @format */

/* eslint-disable import/first */

window.__cspNonce = "my-static-nonce";

const originalCreateElement = document.createElement;
document.createElement = function (tagName, options) {
  const el = originalCreateElement.call(document, tagName, options);
  if ((tagName === "style" || tagName === "script") && window.__cspNonce) {
    el.setAttribute("nonce", window.__cspNonce);
  }
  return el;
};

import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// scroll bar
import "simplebar/src/simplebar.css";
import "./App.scss";

import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

//
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import store, { persistor } from "./store";
import { SnackbarProvider } from "notistack";
// ----------------------------------------------------------------------

const cache = createCache({ key: "css", nonce: window.__cspNonce });

ReactDOM.render(
  <CacheProvider value={cache}>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
        <HelmetProvider>
          <BrowserRouter basename={process.env.REACT_APP_API_BASENAME}>
            <SnackbarProvider
              maxSnack={3}
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <App />
            </SnackbarProvider>
          </BrowserRouter>
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </CacheProvider>,
  document.getElementById("root")
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
